import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: the Marketing › Social media crumb above the hub and each network's section. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/social')({
  staticData: { crumb: 'common:nav.social' },
  component: Outlet,
});
